import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class GetReferralTransactionsArgs {
  @Field(t => Int, { nullable: true })
  page?: number

  @Field(t => Int, { nullable: true })
  limit?: number
}
